import React, {Component} from "react"
import {get} from "lodash"
import {Col} from "react-bootstrap"

import {connect} from "@irati/store"
import Validation, {ValidationInput} from "@irati/utils/validation"
import {FormGroup} from "@irati/ui/src/Form"
import ErrorText from "@irati/ui/src/ErrorText"
import id from "@irati/utils/id"
import {FormattedMessage, getResolvedMessage, injectIntl} from "@irati/utils/lang"
import TrophiesQuery from "@irati/recognition/apollo/query/Trophies"
import {ReduxState} from "@irati/store/types"
import addTrophy from "@irati/ui/images/trophy-empty.png"
import TrophyImg from "@irati/ui/src/Trophy"
import Close from "@irati/ui/src/Close"

import {Item, Trophy} from "./types"
import InlineTrophySlider from "./InlineTrophy"
import {
  ComponentToHideOnExpandContainer,
  FlexRow,
  Label,
  Text,
  TextButton,
  TrophyContainer,
  TrophyWrapper,
  Wrapper
} from "./styled"

import {TROPHY_SIZE, DEFAULT_WIDTH_OF_TROPHY_SLIDER, PROPERTY} from "./constants"

export const schema = Validation.string("platform.defaultValidation.required")

interface Props {
  componentToHideOnExpand(): React.ReactNode,
  isPhone: boolean,
  item: Item,
  label?: string,
  onChange(trophy: Trophy): void,
  sliderWidth: string
}

interface State {
  errorMsg?: string,
  isTrophySelected: boolean,
  value: string
}

class TrophyPicker extends Component<Props, State> {
  static defaultProps = {
    id: "itemContainingTrophy",
    label: "platform.fields.poll.trophy.label",
    sliderWidth: DEFAULT_WIDTH_OF_TROPHY_SLIDER,
    validation: schema
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      isTrophySelected: false,
      value: this.getTrophy(props.item)
    }
  }
  validation = new ValidationInput(this)

  componentDidUpdate(prevProps: Props, prevState: State) {
    this.validation.update(prevProps, prevState)
  }

  componentWillUnmount() {
    this.validation.destroy()
  }

  getTrophy = (challenge: any) => {
    const {trophy} = challenge
    return get(trophy, "href")
  }

  handleButtonClick = (isTrophySelected = true) => {
    this.setState({isTrophySelected, errorMsg: undefined})
  }

  handleTrophySelect = (trophy: Trophy) => {
    this.setState({
      isTrophySelected: false,
      errorMsg: undefined,
      value: get(trophy, "href")
    })

    this.props.onChange(trophy)
  }

  setError = (errorMsg: string) => {
    this.setState({errorMsg})
  }

  render() {
    const {item, isPhone, componentToHideOnExpand, sliderWidth} = this.props
    const {value, errorMsg, isTrophySelected} = this.state
    const showTrophySelector = isTrophySelected || isPhone

    return (
      <FlexRow>
        <ComponentToHideOnExpandContainer isTrophySelected={showTrophySelector}>
          {componentToHideOnExpand()}
        </ComponentToHideOnExpandContainer>
        <TrophyWrapper isTrophySelected={showTrophySelector}>
          <TrophyContainer isTrophySelected={showTrophySelector}>
            <FormGroup>
              <Col xs={12}>
                <Label error={errorMsg}>
                  {getResolvedMessage(this, "label")}
                </Label>
                {isTrophySelected && <Close right="15px" onClick={() => this.handleButtonClick(false)} />}
              </Col>
              <Col xs={12}>
                <Wrapper isTrophySelected={showTrophySelector} error={!!errorMsg}>
                  <TrophiesQuery>
                    {({data: {trophies}}) => (
                      <InlineTrophySlider
                        updateError={this.setError}
                        show={showTrophySelector}
                        item={item}
                        onChange={this.handleTrophySelect}
                        sliderWidth={sliderWidth}
                        trophies={trophies.results} />
                    )}
                  </TrophiesQuery>
                  {!showTrophySelector &&
                  <TextButton
                    id={id(`${PROPERTY}_addBtn`, this.props)}
                    inline={false}
                    onClick={() => this.handleButtonClick(true)}>
                    <TrophyImg src={value || addTrophy} size={`${TROPHY_SIZE - 20}px`} isSet={!!value} />
                    {!value && <Text size={TROPHY_SIZE}><FormattedMessage id="platform.fields.trophy.text" /></Text>}
                  </TextButton>}
                  {errorMsg && <div>
                    <ErrorText id={id("trophyCopyError", this.props)} small>
                      {getResolvedMessage(this, "errorMsg", this.state)}
                    </ErrorText>
                  </div>}
                </Wrapper>
              </Col>
            </FormGroup>
          </TrophyContainer>
        </TrophyWrapper>
      </FlexRow>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isPhone: get(mq, "lessThan.medium", false)
})

export default injectIntl(connect(mapStateToProps)(TrophyPicker))
